import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./AiBanner.css";
import { useNavigate } from "react-router-dom";

 function AiBanner() {
  const [isOpen, setIsOpen] = useState(true);

  const navigate = useNavigate();
  const hideModalClose = () => {
    sessionStorage.setItem("ShowAiBanner", false);
    setIsOpen(false);
  };
  return isOpen ? (
    <div className="zoya-ai-container">
      <AnimatePresence>
        {
          isOpen ? (
            <motion.div
              key="modal"
              className="fullscreen-modal"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{
                opacity: 0,
                transition: { duration: 0.4 },
              }}
            >
              {/* Modal with background image */}
              <motion.div layoutId="modal-to-button" className="modal-image-bg">
                <button
                  className="close-icon"
                  onClick={() => hideModalClose()}
                  aria-label="Close"
                >
                  ✕
                </button>
                <div className="modal-overlay">
                  <h2>Ask the Zoya AI </h2>
                  <p>Type your question and get instant AI-powered insights!</p>
                  <button
                    className="close-btn"
                    onClick={() => {
                      hideModalClose();
                      navigate("/zoya-ai");
                    }}
                  >
                    Ask Zoya Now
                  </button>
                  <h2
                    style={{
                      fontSize: "1.2rem",
                    }}
                  >
                    Betacode CRM
                  </h2>
                  <p
                    style={{
                      fontSize: "0.7rem",
                    }}
                  >
                    Now powered by AI
                  </p>
                </div>
              </motion.div>
            </motion.div>
          ) : null
          // (
          //   <motion.div
          //     key="button"
          //     layoutId="modal-to-button"
          //     initial={{ opacity: 0, scale: 0.8 }}
          //     animate={{ opacity: 1, scale: 1 }}
          //     transition={{ type: "spring", stiffness: 150 }}
          //   >
          //     <button className="ask-ai-btn" onClick={() => setIsOpen(true)}>
          //       Ask Zoya AI
          //     </button>
          //   </motion.div>
          // )
        }
      </AnimatePresence>
    </div>
  ) : null;
}

export default AiBanner;
